let timeStamp = value => {
    let time = new Date(value)
    let year = time.getFullYear()
    let month = time.getMonth() + 1
    let date = time.getDate()
    month = month < 10 ? '0' + month : month
    return year + '-' + month + '-' + date
}

export {
    timeStamp
}


// WEBPACK FOOTER //
// ./src/filter/filter.js